module.exports = __webpack_public_path__ + "static/media/up-arrow.b008fe42.svg";